import { render, staticRenderFns } from "./RecurringPaymentTerms.vue?vue&type=template&id=312d9b30&scoped=true"
import script from "./RecurringPaymentTerms.vue?vue&type=script&lang=js"
export * from "./RecurringPaymentTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d9b30",
  null
  
)

export default component.exports